import { render, staticRenderFns } from "./Ugc.vue?vue&type=template&id=7ea9b617&scoped=true&"
import script from "./Ugc.vue?vue&type=script&lang=js&"
export * from "./Ugc.vue?vue&type=script&lang=js&"
import style0 from "./Ugc.vue?vue&type=style&index=0&id=7ea9b617&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea9b617",
  null
  
)

export default component.exports